module.exports = __webpack_public_path__ + "img/dollar.63f7adb0.png";